import { GridColDef } from '@mui/x-data-grid';
import {
  DbLocation,
  HandlersProgramLocationResponse,
  useDeleteApiProgramsByIdLocationsAndLocationIdMutation,
  useGetApiLocationsQuery,
  useGetApiProgramsByIdLocationsQuery,
  usePostApiProgramsByIdLocationsMutation,
} from '../../../../app/athenaApiGen';
import AdminPatternBJoinPanel from '../AdminPatternBJoinPanel';

const columns: GridColDef<HandlersProgramLocationResponse>[] = [
  { field: 'name', headerName: 'Location', flex: 1.2 },
  { field: 'locationCode', headerName: 'Code', flex: 0.6 },
  { field: 'locationType', headerName: 'Type', flex: 0.8 },
  { field: 'locationCity', headerName: 'City', flex: 0.8 },
  { field: 'locationState', headerName: 'State', flex: 0.4 },
];

const AdminProgramLocationsPanel = () => (
  <AdminPatternBJoinPanel<HandlersProgramLocationResponse, DbLocation>
    tableName="Program Location"
    apiPath="/api/programs/{id}/locations"
    parentType="program"
    useList={(parentId) =>
      useGetApiProgramsByIdLocationsQuery(
        { id: parentId },
        { skip: !parentId },
      )
    }
    useAdd={usePostApiProgramsByIdLocationsMutation}
    useRemove={useDeleteApiProgramsByIdLocationsAndLocationIdMutation}
    buildAddArg={(parentId, child) => ({
      id: parentId,
      handlersAddProgramLocationRequest: { locationId: child.locationId ?? '' },
    })}
    buildRemoveArg={(parentId, row) => ({
      id: parentId,
      locationId: row.locationId ?? '',
    })}
    useChildList={() => useGetApiLocationsQuery()}
    childPkAccessor="locationId"
    childLabelAccessor="name"
    joinChildIdAccessor="locationId"
    columns={columns}
  />
);

export default AdminProgramLocationsPanel;
